import { ActionType, getType } from 'typesafe-actions';

import { DebtPricerActionType } from '../../debtReducer';

import * as valuationActions from './actions';

type ValuationActionType = ActionType<typeof valuationActions>;

export type ValuationState = {
  curve_date: string | null;
  valuation_date: string | null;
};

export const ValuationInitialState: ValuationState = {
  curve_date: null,
  valuation_date: null,
};

const valuationReducer = (
  state: ValuationState = ValuationInitialState,
  action: DebtPricerActionType | ValuationActionType,
): ValuationState => {
  switch (action.type) {
    case getType(valuationActions.updateValuationDatesStateFromForm): {
      return {
        ...state,
        ...action.payload.data,
      };
    }
    default:
      return state;
  }
};

export default valuationReducer;
